import app from 'flarum/forum/app';
import Badge from 'flarum/common/components/Badge';
import highlight from 'flarum/common/helpers/highlight';

import { canLeadClub, clubForDiscussion } from '../../common/clubs';

/**
 * Adds "@shortname" for the current club to flarum/mentions' @ suggestions.
 *
 * Only inside the club's own discussion, and only for the people whose
 * mention actually notifies the club (see NotifyClubMentions.php), so an
 * ordinary member is never offered something that would do nothing.
 *
 * Implements flarum/mentions' MentionableModel interface. Clubs are not store
 * models, so each suggestion is a small object with the `id()` that the
 * suggestion list keys results by.
 */
export default class ClubMention {
  constructor(format) {
    this.format = format;
  }

  type() {
    return 'happydigital-club';
  }

  initialResults() {
    const club = clubForDiscussion(currentDiscussion());

    if (!club || !canLeadClub(club)) return [];

    return [{ id: () => 'club-' + club.id, club }];
  }

  search() {
    return Promise.resolve([]);
  }

  replacement(item) {
    return this.format.format(item.club.slug);
  }

  suggestion(item, typed) {
    const club = item.club;
    const handle = '@' + club.slug;

    return [
      <Badge className="Avatar Badge Badge-icon" color={club.color || undefined} type="club" icon={club.icon || 'fas fa-users'} />,
      <span className="username">{typed ? highlight(handle, typed) : handle}</span>,
      <span className="ClubMention-hint">{app.translator.trans('happydigital-clubs.forum.mention.suggestion_hint', { club: club.name })}</span>,
    ];
  }

  matches(item, typed) {
    const club = item.club;
    const query = (typed || '').toLowerCase();

    if (!query) return true;

    return [club.slug, club.name].some((text) => String(text || '').toLowerCase().indexOf(query) === 0);
  }

  maxStoreMatchedResults() {
    return null;
  }

  enabled() {
    return true;
  }
}

/**
 * The discussion being replied to: from the open composer when there is one,
 * otherwise the discussion page being viewed.
 */
function currentDiscussion() {
  const body = app.composer && app.composer.body;
  const attrs = body && body.attrs;

  if (attrs && attrs.discussion) return attrs.discussion;
  if (attrs && attrs.post && attrs.post.discussion) return attrs.post.discussion();

  return app.current && app.current.get ? app.current.get('discussion') : null;
}
